module.exports = __webpack_public_path__ + "assets/img/price.67bc024e.svg";